<template>
  <div class="detail-box">
    <template v-for="(item, index) in props.list" :key="index">
      <div class="detail-box-item" v-if="!isHide(item.hide)">
        <template v-if="item.labelSolt">
          <slot :name="item.prop + 'Header'"></slot>
        </template>
        <div class="detail-box-header" v-else>{{ $lang(item.label) }}</div>

        <template v-if="item.contentSolt">
          <slot :name="item.prop + 'Content'"></slot>
        </template>
        <div class="detail-box-content" v-else>
          <template v-for="(ele, i) in item.children" :key="'ele-' + i">
            <div
              class="detail-content-item"
              :class="ele.span ? 'detail-content-item-' + ele.span : ''"
              v-if="!isHide(ele.hide)"
            >
              <template v-if="ele.viewSolt">
                <slot :name="ele.prop + 'InfoHeader'"></slot>
              </template>
              <template v-else>
                <template v-if="ele.labelSolt">
                  <slot :name="ele.prop + 'Label'"></slot>
                </template>
                <label class="detail-content-header" v-else>{{ $lang(ele.label) }}：</label>
                <template v-if="ele.contentSolt">
                  <slot :name="ele.prop + 'Content'"></slot>
                </template>
                <template v-else>
                  <div
                    class="detail-content-info"
                    v-if="ele.fomatterCustom"
                    :class="ele.customColor ? ele.customColor : ''"
                  >
                    {{ $lang(ele.fomatterCustom(ele)) }}
                  </div>
                  <div class="detail-content-info" v-else :class="ele.customColor ? ele.customColor : ''">
                    {{ $lang(props.detailData[ele.prop]) }}
                  </div>
                </template>
              </template>
            </div>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>
<script lang="ts" setup name="OrderDetail">
  import { reactive, ref } from 'vue'
  type Props = {
    list: Array<any>
    detailData: {}
  }
  const props = defineProps<Props>()

  const isHide = (hide?: boolean | ((data: any) => boolean)) => {
    if (typeof hide === 'function') {
      return hide(props.detailData)
    }
    return !!hide
  }
</script>
<style lang="less" scoped>
  .detail-box {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    &-item {
      .detail-box-header {
        border-bottom: 1px solid #f5f5f5;
        padding: 5px 0;
      }
      .detail-box-header::before {
        content: '';
        display: inline-block;
        border-left: 4px solid @primary-color;
        height: 14px;
        margin-right: 8px;
        vertical-align: middle;
      }
      .detail-box-content {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        padding: 10px 0;
        .detail-content-item {
          width: 25%;
          margin-bottom: 8px;
          .detail-content-header {
            color: #b9b9c6;
          }
          .detail-content-info::before {
          }
          .detail-content-info {
          }
        }
        .detail-content-item-12 {
          width: 100%;
        }
        .detail-content-item-9 {
          width: 75%;
        }
        .detail-content-item-6 {
          width: 50%;
        }
        .detail-content-item-3 {
          width: 33%;
        }
      }
    }
  }
  .aaa::before {
    content: '';
    display: inline-block;
    width: 6px;
    height: 6px;
    background-color: @primary-color;
    border-radius: 50%;
    margin-right: 8px;
    vertical-align: middle;
  }
  .aaa {
    color: @primary-color;
  }
</style>
